var quickProductOptions = new Map()
var IS_POPUP_OPENED = false
var BOOST_SD_QUICK_VIEW = 'boost-sd__quick-view'
var VARIANT_PICKER = 'variant-picker'

document.addEventListener('DOMContentLoaded', () => {
	const observeElement = () => {
		const observer = new MutationObserver(() => {
			const quickBuySelection = document.querySelector(
				`.${BOOST_SD_QUICK_VIEW}`
			)
			const productPageSelection = document.querySelector(VARIANT_PICKER)
			if (productPageSelection) {
				const defaultSelection = new VariantPickerRemoveDefault(
					productPageSelection
				)
				defaultSelection.getOptionSelections()
				defaultSelection.initialMaskOptions()
				defaultSelection.onVariantPickerChange()
				const defaultBuyButton = new BuyButtonRemoveDefault(defaultSelection)
				defaultBuyButton.addClickListener()
			} else if (quickBuySelection) {
				IS_POPUP_OPENED = true

				const quickBuyDefaultSelection = new QuickBuyDefaultSelection(
					quickBuySelection
				)
				quickBuyDefaultSelection.setDefaultSelection()
				quickBuyDefaultSelection.maskSelection()
			} else if (IS_POPUP_OPENED) {
				IS_POPUP_OPENED = false
				quickProductOptions.clear()
			}
		})
		observer.observe(document.body, { childList: true, subtree: true })
	}
	observeElement()
})

class QuickBuyDefaultSelection {
	constructor(targetElement) {
		this.IS_POPUP_OPENED = false
		this.BOOST_SD = 'boost-sd__'
		this.BOOST_SD_PRODUCT_SWATCH = `${this.BOOST_SD}product-swatch`
		this.BOOST_SD_QUICK_VIEW = `${this.BOOST_SD}quick-view`
		this.WARNING_ID_BASE = `${this.BOOST_SD}select-warning`
		this.LABEL_CLASS_SELECTED = `${this.BOOST_SD}radio-label--selected`
		this.defaultMasked = []

		this.productOptions = targetElement.querySelectorAll(
			`.${this.BOOST_SD_PRODUCT_SWATCH}`
		)
		Array.from(this.productOptions).forEach((element) =>
			element.addEventListener('click', this.setSelection.bind(this))
		)

		this.buyButtonsContainer = targetElement.querySelector(
			`.${BOOST_SD_QUICK_VIEW}-btn`
		)
		this.buttons = this.buyButtonsContainer.querySelectorAll('button')
		Array.from(this.buttons).forEach((button) =>
			button.addEventListener('click', this.disableButtons.bind(this))
		)
	}

	setDefaultSelection() {
		if (quickProductOptions.size) return
		Array.from(this.productOptions).forEach((option) => {
			if (this.isSingleOption(option)) quickProductOptions.set(option, true)
			else {
				quickProductOptions.set(option, false)
				this.defaultMasked.push(option.querySelector('label'))
			}
		})
	}

	setSelection({ target }) {
		if (target.tagName === 'INPUT') {
			const options = target.closest(`.${this.BOOST_SD_PRODUCT_SWATCH}`)
			quickProductOptions.set(options, true)
			this.removeWarningElement(options)
		}
		if (target.tagName === 'LABEL' && this.defaultMasked.includes(target)) {
			this.defaultMasked.filter((el) => el !== target)
			target.classList.add(this.LABEL_CLASS_SELECTED)
		}
	}

	isSingleOption(optionsContainer) {
		const options = optionsContainer.querySelectorAll('input')
		return Array.from(options).length < 2
	}

	maskSelection() {
		quickProductOptions.forEach((value, key) => {
			if (!value) {
				const label = key.querySelector(`.${this.LABEL_CLASS_SELECTED}`)
				if (label) label.classList.remove(this.LABEL_CLASS_SELECTED)
			}
		})
	}

	isAllSelected() {
		return ![...quickProductOptions.values()].includes(false)
	}

	disableButtons(event) {
		if (!this.isAllSelected()) {
			event.stopImmediatePropagation()
			quickProductOptions.forEach((value, key) => {
				if (!value) {
					this.createWarningElement(key)
				}
			})
		}
	}

	createWarningElement(element) {
		const preparedLegendText = element
			.querySelector(`.${this.BOOST_SD_PRODUCT_SWATCH}-title`)
			.textContent.toLowerCase()
		const warningId = `${this.WARNING_ID_BASE}${preparedLegendText}`

		if (document.getElementById(warningId)) return

		const warning = document.createElement('div')
		warning.id = warningId
		warning.classList.add(this.WARNING_ID_BASE)
		warning.textContent = `Please, select ${preparedLegendText}`
		warning.style.color = 'red'
		warning.style.fontSize = '12px'
		element.append(warning)
	}

	removeWarningElement(element) {
		const warning = element.querySelector(`.${this.WARNING_ID_BASE}`)
		if (warning) warning.remove()
	}
}

class VariantPickerRemoveDefault {
	constructor(productPageSelection) {
		this.variantPicker = productPageSelection
		this.variantPickerOptions = this.variantPicker.querySelectorAll(
			'.variant-picker__option'
		)
		this.warningIdBase = 'selection-warning-for-'
		this.warningClassName = 'selection-warning'
		this.optionSelections = null
	}

	getOptionSelections() {
		if (window.optionSelections) {
			this.optionSelections = window.optionSelections
		} else {
			this.createSelectionMap(this.variantPicker)
		}
	}

	setOptionSelections(key, value) {
		this.optionSelections.set(key, value)
		window.optionSelections = this.optionSelections
	}

	createSelectionMap() {
		this.optionSelections = new Map()
		const legends = this.variantPicker.querySelectorAll('fieldset legend')
		legends.forEach((legend) => {
			this.setOptionSelections(legend.textContent, null)
		})
	}

	onVariantPickerChange() {
		this.variantPicker.addEventListener('click', (event) => {
			if (event.target.tagName === 'INPUT') {
				const fieldset = event.target.closest('fieldset')
				this.addOptionToSelection(fieldset, event.target.id)
				this.removeSelectionMask(event.target)
				this.removeWarnings()
			}
		})
	}

	hasMultipleOptions(fieldset) {
		const inputs = fieldset.querySelectorAll('input')
		return inputs.length > 1
	}

	initialMaskOptions() {
		const optionsToMask = []
		for (const [key, value] of this.optionSelections.entries()) {
			if (!value) {
				const fieldset = this.getFieldsetByLegend(key)
				const checkedOption = fieldset.querySelector('input:checked')
				if (this.hasMultipleOptions(fieldset)) {
					optionsToMask.push(checkedOption)
				} else {
					this.addOptionToSelection(fieldset, checkedOption.id)
				}
			}
		}
		optionsToMask.forEach((option) => {
			this.maskSelection(option)
		})
	}

	maskSelection(element) {
		const color = this.getMaskColor(element.parentElement)
		const borderColor = this.getMaskBorderColor(element.parentElement)
		element.nextSibling.style.borderColor = borderColor
		element.nextSibling.style.color = color
	}

	removeSelectionMask(input) {
		input.nextSibling.style.borderColor = ''
		input.nextSibling.style.color = ''
	}

	addOptionToSelection(fieldset, id) {
		const legend = fieldset.querySelector('legend')
		this.setOptionSelections(legend.textContent, id)
	}

	isAllSelected() {
		return ![...this.optionSelections.values()].includes(null)
	}

	showSelectionWarning() {
		this.optionSelections.forEach((value, key) => {
			if (!value) {
				const fieldset = this.getFieldsetByLegend(key)
				this.createWarningElement(fieldset, key)
			}
		})
		this.scrollIntoWarning()
	}

	getFieldsetByLegend(textContent) {
		const legends = this.variantPicker.querySelectorAll('fieldset legend')
		const legend = Array.from(legends).find(
			(legend) => legend.textContent === textContent
		)
		if (!legend) return null
		return legend.closest('fieldset')
	}

	getMaskBorderColor(element) {
		const label = element.querySelector('input:not(:checked)').nextSibling
		const computedStyle = getComputedStyle(label)
		const borderColor = computedStyle.borderColor
		return borderColor
	}
	getMaskColor(element) {
		const label = element.querySelector('input:not(:checked)').nextSibling
		const computedStyle = getComputedStyle(label)
		const color = computedStyle.color
		return color
	}

	createWarningElement(fieldset, legendText) {
		const preparedLegendText = legendText.toLowerCase().replace(':', '')
		const warningId = `${this.warningIdBase}${preparedLegendText}`

		if (document.getElementById(warningId)) return

		const warning = document.createElement('span')
		warning.id = warningId
		warning.className = this.warningClassName
		warning.textContent = `Please, select ${preparedLegendText}`
		warning.style.color = 'red'
		warning.style.fontSize = '12px'
		fieldset.append(warning)
	}
	scrollIntoWarning() {
		const firstWarningElement = document.querySelector(
			`[id^=${this.warningIdBase}]`
		)
		if (firstWarningElement) {
			firstWarningElement.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
				inline: 'nearest',
			})
		}
	}
	removeWarnings() {
		const warnings = document.querySelectorAll(`.${this.warningClassName}`)
		Array.from(warnings).forEach((warning) => warning.remove())
	}
}

class BuyButtonRemoveDefault {
	constructor(variantPicker) {
		this.variantPicker = variantPicker
		this.buyButton = document.querySelector('buy-buttons')
	}

	addClickListener() {
		this.buyButton.addEventListener('click', (event) => {
			if (!this.variantPicker.isAllSelected()) {
				event.preventDefault()
				this.variantPicker.showSelectionWarning()
			}
		})
	}
}
